/* eslint-disable react/no-danger */
import React, { Component } from 'react'
import { string } from 'prop-types'

import { unescapeHtml } from 'services/utility'

class RichText extends Component {
  componentDidMount() {
    const { content: data } = this.props
    this.execEmbeddedScript(data)
  }

  render() {
    const content = unescapeHtml(this.props.content)
    return (
      <div
        data-module={this.props.name}
        data-module-name={this.props.name}
        data-module-id={this.props.moduleId}
        data-module-type={this.props.type}
        className="rich-text"
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    )
  }

  execEmbeddedScript(data) {
    const scriptRegx = /<script>[^>]*([\s\S]+?)<\/script>/gi
    const embeddedScript = scriptRegx.exec(data)
    if (embeddedScript && embeddedScript[0]) {
      let script = embeddedScript[0]
      script = script.replace(/<script>|<\/script>/gi, '')
      try {
        window.eval(script); // eslint-disable-line
      } catch (error) {
        /* eslint-disable no-console */
        console.error(`Error in RichText while 'eval()' script :: ${error}`)
      }
    }
  }
}

RichText.propTypes = {
  content: string.isRequired,
  name: string,
  moduleId: string,
  type: string,
}

RichText.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default RichText



// WEBPACK FOOTER //
// ./components/rich-text/index.js